import { motion } from 'framer-motion'

export function WorkflowSection() {
  const steps = [
    { num: '01', title: 'Create an account', desc: 'Takes a minute. Free credits included.' },
    { num: '02', title: 'Connect GitHub', desc: 'Secure OAuth authorization.' },
    { num: '03', title: 'Ask the assistant', desc: 'Query repos, issues, or PRs.' },
    { num: '04', title: 'Approve actions', desc: 'Human gate for sensitive writes.' },
    { num: '05', title: 'Review audit trail', desc: 'Full observability of all execution.' },
  ]

  return (
    <section className="py-24 sm:py-32 bg-surface border-y border-line relative overflow-hidden">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 relative z-10">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl font-semibold text-ink tracking-tight mb-4">
            How RepoPilot works.
          </h2>
          <p className="text-lg text-ink-muted leading-relaxed">
            From zero to controlled AI execution in minutes.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-12 md:gap-4 relative">
          <div className="hidden md:block absolute top-7 left-12 right-12 h-px bg-line" />
          <div className="block md:hidden absolute top-10 bottom-10 left-1/2 -translate-x-1/2 w-px bg-line" />
          
          {steps.map((step, i) => (
            <motion.div 
              key={step.num}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.1 }}
              viewport={{ once: true }}
              className="relative flex flex-col items-center md:items-start text-center md:text-left pt-2"
            >
              <div className="w-10 h-10 rounded-full bg-ground border border-line flex items-center justify-center text-primary font-mono text-sm font-semibold mb-6 shadow-card z-10 relative">
                {step.num}
              </div>
              <h3 className="text-base font-semibold text-ink mb-2">{step.title}</h3>
              <p className="text-sm text-ink-muted leading-relaxed max-w-[200px]">{step.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
